module.exports = __webpack_public_path__ + "img/03.c6446917.png";